import { isNil } from 'lodash';
import React, { ReactElement, useEffect, useState } from 'react';
import { CreativeCreditInput } from 'sr-types/lib/person/v1/graphql';
import { FormProvider } from '../../../common/form/FormContext';
import { ValidationRulesType } from '../../../production/helpers/productionUtils';
import {
    creativeCreditsValidationRules,
    creativeCreditsValidationRulesForAnnotations,
    getPersonRefrenceListener,
    validateDateRange
} from '../../person';
import CreativeCreditsModal from './CreativeCreditsModal';

interface CreativeCreditEditorProps {
    createState: CreativeCreditInput;
    setCreateState: (state: CreativeCreditInput) => void;
    isAddCreativeCreditsModalOpen: boolean;
    onClose: () => void;
    onSave: () => void;
    isCreativeCreditSaving: boolean;
    title: string | ReactElement;
    disableTypeField: boolean;
    saveLabel?: string | ReactElement;
    modalBodyAccessory?: ReactElement;
}

export default function CreativeCreditEditor({
    createState,
    setCreateState,
    isAddCreativeCreditsModalOpen,
    onClose,
    onSave,
    isCreativeCreditSaving,
    title,
    disableTypeField,
    saveLabel,
    modalBodyAccessory
}: CreativeCreditEditorProps) {
    const [validationRules, setValidationRules] = useState<ValidationRulesType>({ ...creativeCreditsValidationRules });

    useEffect(() => {
        if (createState) {
            if (createState.dateRange) {
                const validation = { ...creativeCreditsValidationRules };
                const startProp = 'dateRange.start';
                const endProp = 'dateRange.end';

                const startDate = createState.dateRange.start;
                const endDate = createState.dateRange.end;

                validateDateRange(validation, startDate, endDate, startProp, endProp);

                setValidationRules(validation);
            }
            if (isNil(createState.showReference) && createState.showName) {
                setValidationRules(creativeCreditsValidationRulesForAnnotations);
            }
        }
    }, [createState]);

    return (
        <FormProvider
            state={createState}
            setState={setCreateState}
            validationRules={validationRules}
            listeners={[...getPersonRefrenceListener('showReference')]}
        >
            <CreativeCreditsModal
                isOpen={isAddCreativeCreditsModalOpen}
                onClose={onClose}
                onSave={onSave}
                isSaving={isCreativeCreditSaving}
                title={title}
                saveLabel={saveLabel}
                disableTypeField={disableTypeField}
                showReferenceId={createState?.showReference?.id}
                modalBodyAccessory={modalBodyAccessory}
            />
        </FormProvider>
    );
}
